import React, { useEffect, useState } from "react";
import { isAfter } from "date-fns";
import IconFA from "../../../components/icon/icon";
import { useAppointments } from "../../../hooks/useAppointments";
import { useNavigate } from "react-router-dom";
import './appointments.css'

function Appointments() {
    const { allAppointments, fetchAllAppointments } = useAppointments();
    const [showAllAppointments, setShowAllAppointments] = useState(false);
    const navigate = useNavigate();

    const handleCheckboxChange = (e) => {
        setShowAllAppointments(e.target.checked);
    };

    const handleNavigate = (id) => {
        navigate(`/dashboard/appointments/${id}`);
    };

    useEffect(() => {
        fetchAllAppointments();
    }, []);

    const now = new Date();
    const upcomingAppointments = allAppointments.filter((appointment) => isAfter(new Date(appointment.date), now));
    const displayedAppointments = showAllAppointments ? allAppointments : upcomingAppointments;

    return (
        <div className="pageContainer">
            <div className="appointmentsContainer">
                <h3 className="appointmentsHeading">
                    Deine Termine
                </h3>
                <label>
                    <input
                        type="checkbox"
                        checked={showAllAppointments}
                        onChange={handleCheckboxChange}
                    />
                    Vergangene Termine anzeigen
                </label>
                {displayedAppointments.length === 0 ? (
                    <p>Keine Termine verfügbar</p>
                ) : (
                    displayedAppointments.map((appointment, index) => (
                        <div key={index} className="appointmentCont" onClick={() => handleNavigate(appointment._id)}>
                            <p style={{ margin: 0, fontWeight: "bold" }}>
                                <IconFA iconName="calendarDays" fontSize="24px" />&nbsp;
                                {appointment.formattedDate}
                            </p>
                            <p style={{ margin: 0 }}>
                                <IconFA iconName="fileLines" fontSize="24px" />&nbsp;
                                {appointment.description}
                            </p>
                            <p style={{ margin: 0, color: "#555" }}> 
                                <IconFA iconName="user" fontSize="24px"/>&nbsp;
                                {appointment.customerName}
                            </p>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default Appointments;